'use strict';

var WebSocketTransport = require('./WebSocketTransport');

module.exports = {
	WebSocketTransport: WebSocketTransport
};


//////////////////
// WEBPACK FOOTER
// ./~/protoo-client/lib-es5/transports/index.js
// module id = 690
// module chunks = 0